var map = {
	"./decidim/avatar-multiuser.png": 92044,
	"./decidim/brands/facebook.svg": 66978,
	"./decidim/brands/google.svg": 48611,
	"./decidim/brands/twitter-x.svg": 91200,
	"./decidim/cc-badge.png": 30014,
	"./decidim/decidim-logo.svg": 25134,
	"./decidim/default-avatar.svg": 82458,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 26734,
	"./decidim/icons.svg": 46765,
	"./decidim/pattern.png": 36650,
	"./decidim/placeholder-card-g.svg": 53447,
	"./decidim/placeholder-card-l.svg": 47388,
	"./decidim/placeholder.jpg": 53731,
	"./decidim/remixicon.symbol.svg": 44299,
	"./decidim/vendor/social-share-button/douban.svg": 47386,
	"./decidim/vendor/social-share-button/email.svg": 72631,
	"./decidim/vendor/social-share-button/facebook.svg": 49769,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 15435,
	"./decidim/vendor/social-share-button/hacker_news.svg": 46203,
	"./decidim/vendor/social-share-button/linkedin.svg": 56487,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 23776,
	"./decidim/vendor/social-share-button/pinterest.svg": 44601,
	"./decidim/vendor/social-share-button/reddit.svg": 93577,
	"./decidim/vendor/social-share-button/telegram.svg": 11536,
	"./decidim/vendor/social-share-button/tumblr.svg": 55495,
	"./decidim/vendor/social-share-button/twitter.svg": 69798,
	"./decidim/vendor/social-share-button/vkontakte.svg": 79480,
	"./decidim/vendor/social-share-button/wechat.svg": 81219,
	"./decidim/vendor/social-share-button/whatsapp.svg": 63675,
	"./decidim/vendor/social-share-button/x.svg": 67695,
	"./decidim/vendor/social-share-button/xing.svg": 70921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55883;